import { CampaignCardSkeleton } from '@/dashboards/CampaignPlanner/components/CampaignCard/CampaignCardSkeleton';

export const CampaignPlannerSkeleton = () => (
    <div className="space-y-6 animate-pulse">
        {/* Banner Skeleton */}
        <div className="h-40 bg-gray-100 border border-gray-200 rounded-lg p-6 flex gap-4">
            <div className="shrink-0 w-12 h-12 rounded-full bg-gray-200" />
            <div className="flex-1 space-y-3 pt-2">
                <div className="h-5 bg-gray-200 rounded w-1/4" />
                <div className="space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-3/4" />
                    <div className="h-4 bg-gray-200 rounded w-1/2" />
                </div>
                <div className="h-4 bg-gray-200 rounded w-32 mt-4" />
            </div>
            <div className="w-6 h-6 bg-gray-200 rounded" />
        </div>

        {/* Toolbar Skeleton */}
        <div className="flex flex-row justify-end gap-4 flex-wrap-reverse">
            <div className="h-10 w-24 bg-gray-200 rounded-lg" />
            <div className="h-10 w-48 bg-gray-200 rounded-lg" />
        </div>

        {/* Grid Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            {Array.from({ length: 3 }).map((_, i) => (
                <CampaignCardSkeleton key={i} />
            ))}
        </div>
    </div>
);
